export const CLIENT_TYPES = {
    OWNER: "OWNER",
    ROOMER: "TENANT",
};

export const CLIENT_TYPE_LABELS = {
    [CLIENT_TYPES.OWNER]: "Propietario",
    [CLIENT_TYPES.ROOMER]: "Inquilino",
};

export const WHICHENSURE_TYPES = {
    HOUSING: "HOME",
    ASSETS: "BELONGINGS",
    HOUSING_ASSETS: "ALL",
};

export const WHICHENSURE_TYPE_LABELS = {
    [WHICHENSURE_TYPES.HOUSING]: "Casa",
    [WHICHENSURE_TYPES.ASSETS]: "Cosas",
    [WHICHENSURE_TYPES.HOUSING_ASSETS]: "Casa+Cosas",
};

import housingAssets from '../assets/images/icons/housing-assets.svg'
import housingAssetsWhite from '../assets/images/icons/housing-assets-white.svg'
import housing from '../assets/images/icons/housing.svg'
import housingWhite from '../assets/images/icons/housing-white.svg'
import assets from '../assets/images/icons/assets.svg'
import assetsWhite from '../assets/images/icons/assets-white.svg'

export const WHICHENSURE_TYPE_VALUES = [
    {
        id: WHICHENSURE_TYPES.HOUSING_ASSETS,
        description: WHICHENSURE_TYPE_LABELS[WHICHENSURE_TYPES.HOUSING_ASSETS],
        icon: "housing-assets",
        selectedIcon: "housing-assets-white",
        image: housingAssets,
        imageSelected: housingAssetsWhite
    },
    {
        id: WHICHENSURE_TYPES.HOUSING,
        description: WHICHENSURE_TYPE_LABELS[WHICHENSURE_TYPES.HOUSING],
        icon: "housing",
        selectedIcon: "housing-white",
        image: housing,
        imageSelected: housingWhite
    },
    {
        id: WHICHENSURE_TYPES.ASSETS,
        description: WHICHENSURE_TYPE_LABELS[WHICHENSURE_TYPES.ASSETS],
        icon: "assets",
        selectedIcon: "assets-white",
        image: assets,
        imageSelected: assetsWhite
    },
];

export const PLAN_TYPES = {
    CUSTOM: "CUSTOM",
    FIXED: "FULL",
};

export const ZOHO_MASKED_SURNAME = "Pacifico";
